import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children", "elementType", "isFocusable", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeProps as $9BxnE$mergeProps } from "@react-aria/utils";
import $9BxnE$react, { useState as $9BxnE$useState, useMemo as $9BxnE$useMemo } from "react";
import { useFocus as $9BxnE$useFocus } from "@react-aria/interactions";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $5c3e21d68f1c4674$exports = {};
$parcel$export($5c3e21d68f1c4674$exports, "useVisuallyHidden", function () {
  return $5c3e21d68f1c4674$export$a966af930f325cab;
});
$parcel$export($5c3e21d68f1c4674$exports, "VisuallyHidden", function () {
  return $5c3e21d68f1c4674$export$439d29a4e110a164;
});
var $5c3e21d68f1c4674$var$styles = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  margin: '0 -1px -1px 0',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: 1,
  whiteSpace: 'nowrap'
};

function $5c3e21d68f1c4674$export$a966af930f325cab() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var style = props.style,
      isFocusable = props.isFocusable;

  var _$9BxnE$useState = $9BxnE$useState(false),
      _$9BxnE$useState2 = _slicedToArray(_$9BxnE$useState, 2),
      isFocused = _$9BxnE$useState2[0],
      setFocused = _$9BxnE$useState2[1];

  var _$9BxnE$useFocus = $9BxnE$useFocus({
    isDisabled: !isFocusable,
    onFocusChange: setFocused
  }),
      focusProps = _$9BxnE$useFocus.focusProps; // If focused, don't hide the element.


  var combinedStyles = $9BxnE$useMemo(function () {
    if (isFocused) return style;else if (style) return _objectSpread(_objectSpread({}, $5c3e21d68f1c4674$var$styles), style);else return $5c3e21d68f1c4674$var$styles;
  }, [isFocused]);
  return {
    visuallyHiddenProps: _objectSpread(_objectSpread({}, focusProps), {}, {
      style: combinedStyles
    })
  };
}

function $5c3e21d68f1c4674$export$439d29a4e110a164(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var children = props.children,
      _props$elementType = props.elementType,
      Element = _props$elementType === void 0 ? 'div' : _props$elementType,
      isFocusable = props.isFocusable,
      style = props.style,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _$5c3e21d68f1c4674$ex = $5c3e21d68f1c4674$export$a966af930f325cab(props),
      visuallyHiddenProps = _$5c3e21d68f1c4674$ex.visuallyHiddenProps;

  return /*#__PURE__*/$9BxnE$react.createElement(Element, $9BxnE$mergeProps(otherProps, visuallyHiddenProps), children);
}

export { $5c3e21d68f1c4674$export$a966af930f325cab as useVisuallyHidden, $5c3e21d68f1c4674$export$439d29a4e110a164 as VisuallyHidden };